import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './EditMenu.css';
import AddMenuForm from '../../../components/Shop/ManageMenu/AddMenu/AddMenuForm'
import { graphql } from 'react-apollo'
import { flowRight as compose } from 'lodash';
import getMenu from './getMenu.graphql';
import Loader from '../../../components/Common/Loader/Loader';
import getShopCategoryIcons from '../../../actions/ShopCategoryIcon/getShopCategoryIcons.graphql'


class EditMenu extends React.Component {
  render() {
    const {
      menuData: { loading: menuLoading, getMenu },
      iconsData: { loading: iconsLoading, getShopCategoryIcons },
    } = this.props;

    if (menuLoading || iconsLoading) {
      return <Loader type="page" show />;
    }

    let initialValues = {};
    if (getMenu && getMenu.result) {
      initialValues = {
        id: getMenu.result.id,
        menuName: getMenu.result.menuName,
        menuAvailability: getMenu.result.menuAvailability,
        isEnable: getMenu.result.isEnable,
        iconId: getMenu.result.iconId,
        icon: getMenu.result.icon,
      };
    }

    const iconOptions = getShopCategoryIcons?.results || [];

    return (
      <div>
        <AddMenuForm
          initialValues={initialValues}
          iconOptions={iconOptions}
        />
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getMenu, {
    name: 'menuData',
    options: (props) => ({
      variables: { id: props.id },
      fetchPolicy: 'network-only',
      ssr: false,
    }),
  }),
  graphql(getShopCategoryIcons, {
    name: 'iconsData',
    options: {
      fetchPolicy: 'network-only',
      ssr: false,
    },
  })
)(EditMenu);
